import TooltipCustom from '__core/modules/atoms/Tooltip';
import Icon from '__core/modules/atoms/Icons/Icon';
import PropTypes from 'prop-types';
import React from 'react';

function OptionLabel({ icon, iconSize, label, value, tooltip, description }) {
  const content = (
    <div data-testid={`option-${value}`} style={{ alignItems: 'center', display: 'flex', gap: '8px' }}>
      {icon && <Icon color="gray-06" fontSize={iconSize || 'small'} style={{ flexShrink: 0 }} type={icon} />}
      <div className="option-label__text" style={{ flex: 1, minWidth: 0 }}>
        <span className="select-customizable__option-label">{label}</span>
        {description && <div className="select-customizable__option-description">{description}</div>}
      </div>
    </div>
  );
  if (!tooltip) return content;
  return (
    <TooltipCustom title={tooltip} placement="right" variant="secondary">
      {content}
    </TooltipCustom>
  );
}

OptionLabel.propTypes = {
  description: PropTypes.node,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OptionLabel;
